import React, { useMemo } from "react";

const TEAMS_CHANNEL = "teams";
const SLACK_DM_CHANNEL = "slack_dm";

const CHANNEL_LABELS = {
  email: "Email",
  voice: "Voice",
  sms: "SMS",
  slack_dm: "Slack DM",
  teams: "Teams",
  whatsapp: "WhatsApp",
};

function CommPrefs({ register, prefs = {}, fields = [] }) {
  const commFields = useMemo(() => {
    // Never mutate props: clone first.
    const internalFields = [...(fields || [])];

    // Some channel strategies rely on fields not always present in the form field list.
    if (prefs?.[TEAMS_CHANNEL] && !internalFields.includes("azure_ad_object_id")) {
      internalFields.push("azure_ad_object_id");
    }
    if (prefs?.[SLACK_DM_CHANNEL] && !internalFields.includes("slack_id")) {
      internalFields.push("slack_id");
    }

    return internalFields;
  }, [prefs, fields]);
  return Object.entries(prefs || {}).map(([channel, channelFields]) => {
    const allFields = Object.values(channelFields || {});
    if (!allFields.length) return null;

    // Prefer showing only fields that exist on the registration form, but
    // fall back to showing all if the intersection is empty (prevents blank channels).
    let visibleFields = allFields;
    if (commFields.length) {
      const filtered = allFields.filter((f) => commFields.includes(f.key));
      visibleFields = filtered.length ? filtered : allFields;
    }

    return (
      <div className="channel" key={channel}>
        <div className="label">{CHANNEL_LABELS[channel]}</div>
        {visibleFields.map((field) => {
          const key = `communications.${channel}.${field.key}`;
          return (
            <div className="item" key={key}>
              <input
                name={key}
                id={key}
                type="checkbox"
                defaultChecked={!!field.value}
                disabled={!!field.disabled}
                {...register(key, { required: false })}
              />
              <label htmlFor={key}>{field.label}</label>
            </div>
          );
        })}
      </div>
    );
  });
}

export default CommPrefs;
